import type { EntryPoint, EntryPointComponent } from 'react-relay';

import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

import parameters, {
	type confluencePremiumPopupQuery,
} from './__generated__/confluencePremiumPopupQuery.graphql';

export type EntryPointParams = {
	cloudId: string;
	hamsProductKey: string;
};

type PremiumPopupComponent = EntryPointComponent<
	{
		confluencePremiumPopupQuery: confluencePremiumPopupQuery;
	},
	Record<string, never>,
	{
		handleOpenPremiumModal: () => void;
		onClose: (extraInformation?: unknown) => void;
	},
	Record<string, never>
>;

export const entryPoint: EntryPoint<PremiumPopupComponent, EntryPointParams> = createEntryPoint({
	root: JSResourceForInteraction<PremiumPopupComponent>(
		/* webpackChunkName: "@atlaskit-internal_edition-awareness-premium-popup" */ './premium-popup',
		{
			moduleId: 'edition-awareness-premium-popup',
		},
	),
	getPreloadProps: ({ cloudId, hamsProductKey }: EntryPointParams) => ({
		entryPoints: {},
		extraProps: {},
		queries: {
			confluencePremiumPopupQuery: {
				parameters,
				variables: {
					cloudId,
					hamsProductKey,
				},
			},
		},
	}),
});
